var _defs, _path, _path2, _path3, _path4, _path5, _path6, _text, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexPaymentGateway01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#09B2C9;}.b{font-size:57.93px;font-family:Montserrat-Bold, Montserrat;font-weight:700;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M333.79,337.7H118.69a12.5,12.5,0,0,1-12.48-12.48V163.89a3.59,3.59,0,0,1,3.59-3.59h224a12.5,12.5,0,0,1,12.48,12.48v54.67a3.59,3.59,0,1,1-7.18,0V172.78a5.31,5.31,0,0,0-5.3-5.3H113.39V325.22a5.31,5.31,0,0,0,5.3,5.3h215.1a5.31,5.31,0,0,0,5.3-5.3V270.56a3.59,3.59,0,1,1,7.18,0v54.66A12.5,12.5,0,0,1,333.79,337.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M176.15,167.48H109.8a3.58,3.58,0,0,1-3.59-3.59V124.6a7,7,0,0,1,7-7h45.18a3.59,3.59,0,0,1,0,7.18h-45V160.3h62.76a3.59,3.59,0,1,1,0,7.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M300.46,167.48H234.11a3.59,3.59,0,1,1,0-7.18h62.76V124.82h-45a3.59,3.59,0,0,1,0-7.18h45.18a7,7,0,0,1,7,7v39.29A3.59,3.59,0,0,1,300.46,167.48Zm-3.38-42.66Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M234.11,167.48a3.59,3.59,0,0,1-2.23-6.4,46.39,46.39,0,0,0,4-3.57,42.63,42.63,0,0,0,12.74-30.75,45.75,45.75,0,0,0-.29-5.13,43.5,43.5,0,1,0-74,35.88,47.93,47.93,0,0,0,4,3.57,3.59,3.59,0,0,1-4.45,5.63,52.73,52.73,0,0,1-4.62-4.12,50.65,50.65,0,0,1,0-71.66,50.69,50.69,0,0,1,86.17,29.9,52.9,52.9,0,0,1,.33,5.93A49.67,49.67,0,0,1,241,162.59a54.21,54.21,0,0,1-4.62,4.12A3.59,3.59,0,0,1,234.11,167.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.9,274.15H300a3.59,3.59,0,0,1-3.59-3.59V227.45a3.59,3.59,0,0,1,3.59-3.59H360.9a3.59,3.59,0,0,1,3.59,3.59v43.11A3.59,3.59,0,0,1,360.9,274.15ZM303.6,267h53.71V231H303.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M323.35,259.6A10.6,10.6,0,1,1,333.94,249,10.61,10.61,0,0,1,323.35,259.6Zm0-14a3.41,3.41,0,1,0,3.41,3.41A3.42,3.42,0,0,0,323.35,245.59Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(187.52 146.12)"
  }, "P")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 182.01,
    y: 115.98,
    width: 49.29,
    height: 7.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexPaymentGateway01);
export default __webpack_public_path__ + "static/media/Vortex_Payment_Gateway-01.46089502a7ff06bf531b89cf1c178cc7.svg";
export { ForwardRef as ReactComponent };